"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useTerminology;

var _react = require("react");

var _get2 = _interopRequireDefault(require("lodash/get"));

var _usePassiveRedux = _interopRequireDefault(require("@sift/resift/usePassiveRedux"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var defaultTerminology = {
  teamMember: 'team member',
  teamMember_plural: 'team members'
};

function useTerminology() {
  var terminology = (0, _usePassiveRedux["default"])(function (state) {
    return (0, _get2["default"])(state, ['client', 'terminology'], defaultTerminology);
  });
  var singular = terminology.teamMember;
  var plural = terminology.teamMember_plural;
  var pluralize = (0, _react.useCallback)(function (count) {
    return count === 1 ? singular : plural;
  }, [singular, plural]);
  return (0, _react.useMemo)(function () {
    return {
      singular: singular,
      plural: plural,
      pluralize: pluralize
    };
  }, [singular, plural, pluralize]);
}